<template>
  <span class="hb-copy">
    <hb-icon-button
      :icon="copied ? 'CheckIcon' : 'CopyIcon'"
      :tone="copied ? 'success' : 'primary'"
      :label="$t('influencer_panel.copy')"
      @click="copy"
    />
    <hb-icon-button
      v-if="shareable"
      icon="Share2Icon"
      tone="primary"
      :label="$t('influencer_panel.share')"
      @click="share"
    />
  </span>
</template>

<script>
import HbIconButton from './HbIconButton.vue'

/**
 * Copiar (e opcionalmente compartilhar) um link.
 *
 * Usa o `$copyText` do vue-clipboard2, ja registrado em libs/clipboard — o painel tinha
 * uma implementacao propria com fallback de `document.execCommand` que nao precisa existir.
 *
 * O compartilhar depende da Web Share API, que so existe em contexto seguro e sobretudo
 * em mobile; quando nao ha, o botao nem aparece, em vez de dar erro no clique.
 */
export default {
  name: 'HbCopyButton',
  components: { HbIconButton },
  props: {
    text: { type: String, required: true },
    shareTitle: { type: String, default: '' },
    /** Desliga o botao de compartilhar mesmo onde a API existe. */
    allowShare: { type: Boolean, default: true },
  },
  data: () => ({ copied: false, copyTimer: null }),
  computed: {
    shareable() {
      return this.allowShare && typeof navigator !== 'undefined' && !!navigator.share
    },
  },
  beforeDestroy() {
    clearTimeout(this.copyTimer)
  },
  methods: {
    copy() {
      this.$copyText(this.text).then(() => {
        this.copied = true
        this.$emit('copied')
        clearTimeout(this.copyTimer)
        this.copyTimer = setTimeout(() => { this.copied = false }, 2000)
      }).catch(() => {
        // Navegador sem permissao de area de transferencia: avisa, em vez de fingir que
        // copiou (o feedback verde e a unica confirmacao que o usuario tem).
        this.$vs.notify({ text: this.$t('influencer_panel.copy_failed'), color: 'warning' })
      })
    },
    share() {
      navigator.share({ title: this.shareTitle || document.title, url: this.text }).catch(() => {
        // O usuario cancelar a folha de compartilhamento rejeita a promise. Nao e erro.
      })
    },
  },
}
</script>

<style scoped>
.hb-copy {
  display: inline-flex;
  gap: 0.35rem;
}
</style>
